/**
 *  scan QR analytics types
 */

export enum ScanQrAnalyticsType {
    CHECK_IN = 1,
    BOOTH = 2,
}
